import { Transforms } from 'slate';
import {
  setDefaults,
  isCollapsed,
  unwrapNodesByType,
} from '@udecode/slate-plugins';
import linkElement from './element';

export const setLink = ({ editor, url, options }) => {
  const { at, link } = setDefaults(options, linkElement);
  const wrappedElement = {
    type: link.type,
    url,
  };

  Transforms.setNodes(editor, wrappedElement, { at, split: true });
};

export const wrapLink = ({ editor, url, options }) => {
  const { at, link } = setDefaults(options, linkElement);

  Transforms.wrapNodes(
    editor,
    {
      type: link.type,
      url,
      children: [],
    },
    { at, split: true }
  );
};

export const unwrapLink = ({ editor, options }) => {
  const { at, link } = setDefaults(options, linkElement);
  unwrapNodesByType(editor, link.type, { at });
};

export const upsertLinkAtSelection = (editor, url, options) => {
  if (!editor) return null;

  const { link, wrap } = setDefaults(options, linkElement);

  if (!wrap && isCollapsed(editor.selection)) {
    return Transforms.insertNodes(editor, {
      type: link.type,
      url,
      children: [{ text: url }],
    });
  }

  unwrapNodesByType(editor, link.type, { at: editor.selection });

  wrapLink({
    editor,
    url,
    options: {
      link,
      at: editor.selection,
    },
  });

  Transforms.collapse(editor, { edge: 'end' });
  return null;
};
